'use es6';

import { Component } from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import { EERIE } from 'HubStyleTokens/colors';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import CommonWelcomeMessageContent from './CommonWelcomeMessageContent';
import AIWelcomeMessageContent from './AIWelcomeMessageContent';
import { WidgetLocationProp } from './constants/WidgetLocations';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import WelcomeMessageAvatars from './WelcomeMessageAvatars';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyleWrapper = styled.div.withConfig({
  displayName: "InitialMessageBubble__StyleWrapper",
  componentId: "sc-1tbgr2m-0"
})(["position:relative;margin-top:", ";"], ({
  isUngatedForUpdatedUI
}) => isUngatedForUpdatedUI ? '40px' : '24px');
export const CloseButton = styled(VizExIconButton).withConfig({
  displayName: "InitialMessageBubble__CloseButton",
  componentId: "sc-1tbgr2m-1"
})(["position:absolute;top:0;right:0;width:36px;height:36px;color:", ";z-index:2;&:focus-visible{outline-offset:-2px;}"], EERIE);
export default class InitialMessageBubble extends Component {
  constructor(...args) {
    super(...args);
    this.onClose = () => {
      try {
        this.props.onClose();
      } catch (err) {
        reportError({
          error: 'InitialMessageBubble Mysterious Error',
          fingerprint: ['ComponentError'],
          tags: {
            componentDidCatch: true
          }
        });
      }
    };
    this.renderWelcomeMessageContent = () => {
      const {
        widgetLocation,
        initialMessage,
        onClick,
        mobile,
        chatHeadingConfig,
        chatHeadingResponders,
        publishAIInitialMessage,
        isAIChatBot,
        gdprConsentEnabled,
        isIOSMobile,
        isUngatedForUpdatedUI
      } = this.props;
      const showWelcomeMessageAsButton = !isAIChatBot || isAIChatBot && gdprConsentEnabled;
      if (isUngatedForUpdatedUI) {
        return /*#__PURE__*/_jsx(AIWelcomeMessageContent, {
          initialMessage: initialMessage,
          onClose: this.onClose,
          publishMessage: publishAIInitialMessage,
          widgetLocation: widgetLocation,
          mobile: mobile,
          isAIChatBot: isAIChatBot,
          onClick: onClick,
          gdprConsentEnabled: gdprConsentEnabled,
          isIOSMobile: isIOSMobile,
          showWelcomeMessageAsButton: showWelcomeMessageAsButton,
          children: /*#__PURE__*/_jsx(WelcomeMessageAvatars, {
            chatHeadingConfig: chatHeadingConfig,
            chatHeadingResponders: chatHeadingResponders,
            mobile: mobile,
            isAIChatBot: isAIChatBot,
            onClick: onClick
          })
        });
      }
      return /*#__PURE__*/_jsx(CommonWelcomeMessageContent, {
        onClick: onClick,
        initialMessage: initialMessage,
        onClose: this.onClose,
        chatHeadingConfig: chatHeadingConfig,
        chatHeadingResponders: chatHeadingResponders,
        mobile: mobile
      });
    };
  }
  componentDidMount() {
    this.props.onUpdateSize();
  }
  componentDidUpdate(nextProps) {
    if (nextProps.initialMessage !== this.props.initialMessage) {
      this.props.onUpdateSize();
    }
  }
  render() {
    const {
      mobile,
      widgetLocation,
      isAIChatBot,
      isUngatedForUpdatedUI
    } = this.props;
    return /*#__PURE__*/_jsx(StyleWrapper, {
      className: mobile ? "mobile" : "",
      "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.welcomeMessage'),
      role: "status",
      widgetLocation: widgetLocation,
      isAIChatBot: isAIChatBot,
      isUngatedForUpdatedUI: isUngatedForUpdatedUI,
      children: this.renderWelcomeMessageContent()
    });
  }
}
InitialMessageBubble.displayName = 'InitialMessageBubble';
InitialMessageBubble.propTypes = {
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List).isRequired,
  gdprConsentEnabled: PropTypes.bool.isRequired,
  initialMessage: PropTypes.string.isRequired,
  isAIChatBot: PropTypes.bool.isRequired,
  isIOSMobile: PropTypes.bool.isRequired,
  isUngatedForUpdatedUI: PropTypes.bool,
  mobile: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateSize: PropTypes.func.isRequired,
  publishAIInitialMessage: PropTypes.func.isRequired,
  widgetLocation: WidgetLocationProp
};
InitialMessageBubble.defaultProps = {
  mobile: false,
  onUpdateSize: () => {}
};